import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';

// The result of each upload queued with a resultKey (see processFileAndUpload),
// so a caller can wait for its own file rather than any upload finishing.
export const useUploadResultsStore = create(
  subscribeWithSelector((set) => ({
    results: {}, // { [resultKey]: { status: 'done', imageId } | { status: 'failed' } }
    // Keys someone may still read a result for, from when the upload is queued
    // until its wait ends. A result for any other key (one arriving after the
    // wait gave up, or from an upload replayed on remount or after a reload)
    // would never be cleared, so it isn't stored.
    tracked: {}, // { [resultKey]: true }
    trackResult: (key) =>
      set((state) => ({ tracked: { ...state.tracked, [key]: true } })),
    setResult: (key, result) =>
      set((state) =>
        state.tracked[key]
          ? { results: { ...state.results, [key]: result } }
          : state,
      ),
    releaseResult: (key) =>
      set((state) => {
        if (!state.tracked[key]) return state;
        const results = { ...state.results };
        const tracked = { ...state.tracked };
        delete results[key];
        delete tracked[key];
        return { results, tracked };
      }),
  })),
);
